import { useQuery } from '@tanstack/react-query';
import { getUnderwritingSettings } from '../functions';

// Company-level underwriting settings (interest rate, hold months, title rate, etc.).
// These rarely change — once a company sets them they stay put for weeks/months.
// Cached aggressively so opening 10 leads in a row issues 1 read, not 10.
//
// Returns the same { status, data, message } shape getUnderwritingSettings does
// directly, so the existing call sites keep working.
export function useUnderwritingSettings(companyId) {
    return useQuery({
        queryKey: ['underwritingSettings', companyId],
        enabled: !!companyId,
        staleTime: 10 * 60_000,   // 10 min — way longer than the page cache
        gcTime: 30 * 60_000,
        queryFn: () => getUnderwritingSettings(companyId)
    });
}
